export interface ChartMargin {
  top: number
  right: number
  bottom: number
  left: number
}

export interface ChartConfig {
  width?: number
  height?: number
  margin?: ChartMargin
  responsive?: boolean
  animate?: boolean
  className?: string
}

export interface DataPoint {
  label: string
  value: number
}

export interface TimeSeriesDataPoint {
  date: Date | string | number
  value: number
}

export interface Series {
  label: string
  values: TimeSeriesDataPoint[]
  color?: string
}

export interface ThresholdLine {
  value: number
  color: string
  label?: string
  dashed?: boolean
}

export const DEFAULT_MARGIN: ChartMargin = {
  top: 20,
  right: 20,
  bottom: 40,
  left: 50,
}

export const CHART_COLORS = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
  'var(--chart-6)',
  'var(--chart-7)',
  'var(--chart-8)',
] as const
